export const UTIL_CONSTS = {
    TOGGLE_LEFT_SIDE_MENU: "TOGGLE_LEFT_SIDE_MENU",
    START_LOADING: "START_LOADING",
    END_LOADING: "END_LOADING",
    SET_PAGE_OFFSET:"SET_PAGE_OFFSET",
};
